import {computed} from 'vue'
import get from 'lodash/get'
import fromPairs from "lodash/fromPairs";
import compact from "lodash/compact";
import map from "lodash/map";
import isEmpty from "lodash/isEmpty";
import find from "lodash/find";
import isNull from "lodash/isNull";
import { jurisdictionList, catchAllJurisdictionList } from './jurisdictionSwitch/jurisdictionList';
import { mapDayJSLocale, mapNumeralLocale } from './jurisdictionSwitch/mapLocale';
import dayjs from 'dayjs';
import 'dayjs/locale/de';
import 'dayjs/locale/de-at';
import 'dayjs/locale/de-ch';
import 'dayjs/locale/en';
import 'dayjs/locale/en-gb';
import 'dayjs/locale/it';
import 'dayjs/locale/fr';
import 'dayjs/locale/fr';
import 'dayjs/locale/fr';
import 'dayjs/locale/es';
import 'dayjs/locale/pl';
import 'dayjs/locale/nl';
import 'dayjs/locale/bg';
import 'dayjs/locale/bs';
import 'dayjs/locale/zh-cn';
import 'dayjs/locale/da';
import 'dayjs/locale/et';
import 'dayjs/locale/fi';
import 'dayjs/locale/el';
import 'dayjs/locale/el';
import 'dayjs/locale/he';
import 'dayjs/locale/ga';
import 'dayjs/locale/ja';
import 'dayjs/locale/hr';
import 'dayjs/locale/lv';
import 'dayjs/locale/lt';
import 'dayjs/locale/mt';
import 'dayjs/locale/pt';
import 'dayjs/locale/ro';
import 'dayjs/locale/ru';
import 'dayjs/locale/sl';
import 'dayjs/locale/sv';
import 'dayjs/locale/sk';
import 'dayjs/locale/cs';
import 'dayjs/locale/tr';
import 'dayjs/locale/tr';
import 'dayjs/locale/hu';
import 'dayjs/locale/ar';
import numeral from 'numeral';

export function useJurisdictionSwitch() {
    const fallbackJurisdiction = find(jurisdictionList, ['i18n', 'en-US']);
    const jurisdictionListCombined = jurisdictionList.concat(catchAllJurisdictionList);

    function getJurisdictionFromLocalStorage() {
        if(localStorage)
            return JSON.parse(localStorage.getItem('jurisdiction'));
    }

    function getJurisdictionByLocale(locale, catchAll = false) {
        return find((catchAll) ? jurisdictionListCombined : jurisdictionList, ['i18n', locale]);
    }

    function isJsonString(str) {
        try {
            JSON.parse(str);
        } catch (e) {
            return false;
        }
        return true;
    }

    function setDocumentLanguage(jurisdiction) {
        document.documentElement.setAttribute('lang', get(jurisdiction, 'i18n', 'en'));
    }

    function setJurisdictionInLocalStorage(jurisdiction) {
        if(localStorage)
            localStorage.setItem('jurisdiction', JSON.stringify(jurisdiction));
    }

    function setJurisdiction(locale, jurisdiction) {
        locale.value = jurisdiction.i18n;
        setDocumentLanguage(jurisdiction);
        setJurisdictionInLocalStorage(jurisdiction);
    }

    function setDayJSLocale(jurisdiction) {
        dayjs.locale(mapDayJSLocale(get(jurisdiction, 'i18n', fallbackJurisdiction)));
    }

    function setNumeralLocale(jurisdiction) {
        numeral.locale(mapNumeralLocale(get(jurisdiction, 'i18n', fallbackJurisdiction)));
    }

    async function loadJurisdiction() {
        let urlHash = window.location.hash;
        let urlParams = fromPairs(compact(map(urlHash.slice(1).split('&'), function(item) {if (item) return item.split('=');})));
        let jurisdictionFromUrl = (!isEmpty(urlParams))
            ? find(jurisdictionList, function(item) {
                return item.i18n == decodeURIComponent(urlParams.i18n);
            })
            : undefined;
        let jurisdictionFromLocalStorage = localStorage.getItem('jurisdiction');
        let jurisdiction = {};
        if (jurisdictionFromUrl) {
            jurisdiction = getJurisdictionByLocale(jurisdictionFromUrl.i18n)
        } else {
            if(isJsonString(jurisdictionFromLocalStorage) && !isNull(jurisdictionFromLocalStorage)){
                jurisdiction = JSON.parse(jurisdictionFromLocalStorage)
            } else {
                jurisdiction = fallbackJurisdiction
            }
        }
        return jurisdiction;
    }

    return {
        jurisdictionList,
        jurisdictionListCombined,
        catchAllJurisdictionList,
        fallbackJurisdiction,
        getJurisdictionFromLocalStorage,
        getJurisdictionByLocale,
        setJurisdictionInLocalStorage,
        setDocumentLanguage,
        setJurisdiction,
        setDayJSLocale,
        setNumeralLocale,
        loadJurisdiction
    }
}